export default __webpack_public_path__ + "static/media/course-black.70dd2505.svg";